exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preview .content[data-v-defa5870]{max-height:300px;overflow:hidden;position:relative}.preview .content[data-v-defa5870]:after{content:\"\";display:block;position:absolute;bottom:0;left:0;right:0;height:100px;background:linear-gradient(180deg,hsla(0,0%,100%,0) 0,#fff)}.actions[data-v-defa5870]{margin-top:12px;text-align:center}.loading[data-v-defa5870]{width:134px;margin:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-defa5870","scoped":true,"sourceMap":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modules/ModuleReadme.vue
// module id = 513
// module chunks = 0